import { render, staticRenderFns } from "./AccommodationServices.vue?vue&type=template&id=2b8168a9&"
import script from "./AccommodationServices.vue?vue&type=script&lang=js&"
export * from "./AccommodationServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports